import * as React from 'react';
import { TourModalMobile } from '../../components/TourModal';
import { shallowEqual, useSelector } from 'react-redux';
import { selectGalleryFactoids, selectProjectName, selectTour } from '../../selectors';
import { CallButtonContainer } from '../CallButtonContainer';
import { CallbackContainer } from '../CallbackContainer';
import { ECallbackWidgetPlacement } from '../../types/callbackWidget';

interface ITourModalContainerMobileProps {
  onClose(): void;
}

export const TourModalContainerMobile: React.FC<ITourModalContainerMobileProps> = ({ onClose }) => {
  const tour = useSelector(selectTour);
  const projectName = useSelector(selectProjectName);
  const factoids = useSelector(selectGalleryFactoids, shallowEqual);

  if (!tour) {
    return null;
  }

  return (
    <TourModalMobile
      tourUrl={tour.url}
      projectName={projectName}
      factoids={factoids}
      callbackButton={<CallbackContainer placement={ECallbackWidgetPlacement.Tour} />}
      phoneButton={<CallButtonContainer />}
      onClose={onClose}
    />
  );
};
